module.exports = __webpack_public_path__ + "img/price3.f83a2140.png";